import React, { Fragment, useState } from 'react';
import T from 'prop-types';

import Modal from '../../../Modal';
import Button from '../../../Buttons/Button';

const UpdateConfirmation = ({ onSwitchAction, onConfirm }) => (
  <Fragment>
    <div className="upsert-export-modal__body">
      <h4 className="upsert-export-modal__title">
        This export has <br /> unsaved changes
      </h4>
    </div>

    <div className="upsert-export-modal__footer">
      <Button size="lg" variant="secondary" onClick={() => onSwitchAction('create')}>
        Generate new export with these settings
      </Button>
      <Button size="lg" onClick={() => onConfirm({ action: 'update' })}>
        Save changes and export
      </Button>
    </div>
  </Fragment>
);

UpdateConfirmation.propTypes = {
  onSwitchAction: T.func.isRequired,
  onConfirm: T.func.isRequired,
};

const CreateConfirmation = ({ onConfirm }) => (
  <Fragment>
    <div className="upsert-export-modal__body">
      <h4 className="upsert-export-modal__title text-center">
        Would you like to save this export for future use?
      </h4>
      <small className="upsert-export-modal__description text-center">
        We’re currently generating your export and will notify you when your it’s ready. If you
        would like to retain these settings for future use, you may save it.
      </small>
    </div>

    <div className="upsert-export-modal__footer">
      <Button
        size="lg"
        variant="secondary"
        onClick={() => onConfirm({ action: 'create', one_time: true })}
      >
        Export without saving
      </Button>
      <Button size="lg" onClick={() => onConfirm({ action: 'create', one_time: false })}>
        Save export
      </Button>
    </div>
  </Fragment>
);

CreateConfirmation.propTypes = {
  onConfirm: T.func.isRequired,
};

const SubmitConfirmationModal = ({ open, action, onConfirm, onClose }) => {
  const [activeAction, setActiveAction] = useState(action);

  const handleConfirm = (params) => {
    onConfirm(params);
    onClose();
  };

  return (
    <Modal
      open={open}
      size="xs"
      closeButtonIconClass="hicon-close-2"
      modalClassName="upsert-export-modal submit-confirmation-modal"
      onClose={onClose}
    >
      {activeAction === 'update' && (
        <UpdateConfirmation onSwitchAction={setActiveAction} onConfirm={handleConfirm} />
      )}

      {activeAction === 'create' && <CreateConfirmation onConfirm={handleConfirm} />}
    </Modal>
  );
};

SubmitConfirmationModal.propTypes = {
  open: T.bool.isRequired,
  action: T.oneOf(['create', 'update']).isRequired,
  onConfirm: T.func.isRequired,
  onClose: T.func.isRequired,
};

export default SubmitConfirmationModal;
